// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"96f08bc3","242":"96f08bc3","291":"96f08bc3","843":"df83cf14","899":"96f08bc3","922":"96f08bc3","948":"96f08bc3"}[chunkId] + ".chunk.css";
};